export const NAMESPACE = "MobileMenuFlyOver";

export const SIDEBAR_INSTANCE_ID = "mobile_menu_flyover_sidebar_instance_id";
